






import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class FormTitle extends Vue {
  @Prop(String) readonly title!: string;
}
